import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import { initializeFirebase } from '../shared/firebase';

async function loadWorld(worldName) {
  const url = `https://firestore.googleapis.com/v1/projects/enigmeta-parcitypate/databases/(default)/documents/worlds/${worldName}`;
  const res = await fetch(url);
  const doc = await res.json();
  return doc.fields.json.stringValue;
}

async function saveWorld(worldName, json) {
  return await firebase.firestore().collection('worlds').doc(worldName).set({ json });
}

initializeFirebase();
const firebaseAuthProvider = new firebase.auth.GoogleAuthProvider();

export default function Raw() {
  let { project } = useParams();
  const [user, setUser] = useState();
  const [world, setWorld] = useState('');

  useEffect(() => {
    firebase.auth().onAuthStateChanged(() => {
      setUser(firebase.auth().currentUser);
    });
    const load = async () => {
      setWorld(await loadWorld(project));
    };
    load();
  }, [project]);

  const handleSave = () => {
    saveWorld(project, world);
  };

  const handleSignIn = async () => {
    await firebase.auth().signInWithPopup(firebaseAuthProvider);
    const user = firebase.auth().currentUser;
    this.setState({ user });
  };

  return (
    <div className="raw" style={{ padding: '2rem' }}>
      <header style={{ marginBottom: '1rem' }}>
        <span className="editor__user">{user && user.email}</span>
        {!user && <button onClick={handleSignIn}>Sign In</button>}
      </header>
      <textarea value={world} onChange={(e) => setWorld(e.target.value)} style={{ width: '500px', height: '500px' }} />
      <br />
      <button onClick={handleSave}>Save</button>
    </div>
  );
}
